/* global modUtils Modalytics */
/**
 * Function to track form submission flow in heap.
 *
 * @export
 * @param {object} properties - {}
 */
let currentData = {};
export function trackFormSubmissionFlow(properties = {}) {
	const _fn = function(data = {}) {
		if (Object.keys(data).length) {
			currentData = Object.assign(currentData, data);
			Modalytics.heap('track', ['Submit Function Call Checkpoint', currentData]);
		}
	};

	if (modUtils.getEnv() !== 'production') {
		_fn(properties);
	} else {
		if (window.heap) {
			_fn(properties);
		} else {
			document.addEventListener('heap.', function() {
				_fn(properties);
			});
		}
	}
}
